import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const deleteSchedules = async (schedules: string[]): Promise<void> => {
  const res = await fetch(`${API_URL}/schedules`, {
    method: 'DELETE',
    body: JSON.stringify({ schedule_ids: schedules }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (res.status === Status.BAD_REQUEST || !res.ok) {
    throw new Error('Could not delete schedule');
  }
};
